import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { projectStatusList } from '@/module/Author/Project';

import { authorSchema, identitySchema, publishedAtSchema } from '@/core/components';

import { currencyList } from '@feature/utils';

export const statusYearSchema = z.object({
  year: z.number(),
  status: z.enum(projectStatusList),
});

export const financingSchema = z.object({
  type: identitySchema.nullable().refine((value): boolean => value !== null, { params: { i18n: 'custom.required' } }),
  financerName: z.string().nullable(),
});

export const projectSchema = z.object({
  title: z.string().min(3),
  contractValue: z.number().min(0),
  currency: z.enum(currencyList),
  statusYear: z.array(statusYearSchema),
  competitionName: z.string().nullable(),
  competition: identitySchema.extend({
    name: z.string(),
  }),

  financing: financingSchema
    .nullable()
    .refine((value): boolean => value !== null, { params: { i18n: 'custom.required' } }),
  competitionType: identitySchema
    .nullable()
    .refine((value): boolean => value !== null, { params: { i18n: 'custom.required' } }),
  registrationNumber: z.string().nullable(),
  contractNo: z.string().nullable(),
  startDate: publishedAtSchema,
  endDate: publishedAtSchema,

  percentObtainedOfMinScore: z.number().nullish(),

  contribution: identitySchema
    .nullable()
    .refine((value): boolean => value !== null, { params: { i18n: 'custom.required' } }),

  authors: z.array(authorSchema).min(1),
});

export const defaultProjectValues: DefaultValues<ProjectSchema> = {
  title: '',
  contractValue: 0,
  currency: 'RON',
  statusYear: [],
  competitionName: '',
  financing: {
    type: null,
    financerName: '',
  },
  competitionType: null,
  registrationNumber: '',
  contractNo: '',
  contribution: null,
};

export type ProjectSchema = z.infer<typeof projectSchema>;
export type StatusYearSchema = z.infer<typeof statusYearSchema>;
